import { cx } from '@linaria/core';
import { useRef, useId } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { useComponentFrameworkState } from '@provider/component-framework';
import { resets } from '@ui/css';
import { IsomorphicPortal, CSSRefTransition } from '@utils/react';
import { wrapper, dialogTransitionDurationMs, dialog, scrollContainer, speechButton, backdrop } from './dialog.style.js';
import { CloseButton } from './util.close-button.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { TransitionSafeFocusOn } from '../containers/focus-on.js';
import { SpeechButton } from '../speech/speech-button.js';

function Dialog(props) {
  const targetSelector = useComponentFrameworkState(state => state.overlayContainerSelector);
  const target = targetSelector && document.querySelector(targetSelector) || undefined;
  return /*#__PURE__*/jsx(IsomorphicPortal, {
    target: target,
    children: /*#__PURE__*/jsx(TransitionGroup, {
      component: null,
      children: props.active && /*#__PURE__*/jsx(CSSRefTransition, {
        timeout: dialogTransitionDurationMs,
        classNames: wrapper,
        children: ref => /*#__PURE__*/jsx(DialogContent, {
          ...props,
          ref: ref
        })
      })
    })
  });
}
function DialogContent(props) {
  const {
    includeSpeechButton = true
  } = props;
  const scrollContainerRef = useRef(null);
  const id = useId();
  return /*#__PURE__*/jsxs("dialog", {
    ref: props.ref,
    open: true,
    className: cx(resets.rootCls, wrapper, props.className),
    children: [/*#__PURE__*/jsx(TransitionSafeFocusOn, {
      transitionEnterDuration: dialogTransitionDurationMs.enter,
      onEscapeKey: props.requiresInteraction ? undefined : props.onClose,
      onClickOutside: props.requiresInteraction ? undefined : props.onClose,
      scrollLock: true,
      focusLock: true,
      allowPinchZoom: true,
      autoFocus: true,
      returnFocus: {
        preventScroll: true
      },
      preventScrollOnFocus: true,
      children: /*#__PURE__*/jsxs("div", {
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: 0,
        id: id,
        className: dialog,
        children: [/*#__PURE__*/jsxs("div", {
          className: scrollContainer,
          ref: scrollContainerRef,
          children: [props.children, !props.requiresInteraction && /*#__PURE__*/jsx(CloseButton, {
            label: "Luk dialog",
            onClose: props.onClose
          })]
        }), includeSpeechButton && /*#__PURE__*/jsx("div", {
          className: speechButton,
          children: /*#__PURE__*/jsx(SpeechButton, {
            rootSelector: `.${dialog}[id="${id}"]`,
            hideWhenEmpty: true,
            defaultTooltip: "Læs op",
            scrollContainerRef: scrollContainerRef,
            withoutGuideBubble: true,
            flagPlacement: "top"
          })
        })]
      })
    }), !props.noBackdrop && /*#__PURE__*/jsx("div", {
      className: backdrop
    })]
  });
}

export { Dialog, DialogContent };
//# sourceMappingURL=dialog.js.map
